/** @format */

import React from 'react'
import Footer from "./footer";
import Navbar from "./navbar";


class About extends React.Component {
	render() {
		return (
			<>
				<Navbar />
				
					<section className='bg-success py-5 margin-about'>
						<div className='container'>
							<div className='row align-items-center py-5'>
								<div className='col-md-8 text-white'>
									<h1>About SabZ</h1>
									<p>
										SabZ is an e-commerce platform dedicated to assisting farmers in
										the sale of horticulture goods.We try to bridge the gap between
										the farmers and the consumers by transporting goods from the
										farm directly to our designated customers.
										{/* both B2B and B2C.  */}
										We extend credit to businesses (among our clientele), as identified
										by our machine learning model, and assist them in extending
										their operations rather than concentrating on day-to-day bills.
										We also make every effort to mitigate post-harvest losses.
									</p>
								</div>
								<div className='col-md-4'>
									<img src='assets/img/favicon.ico' alt='About sabz' />
								</div>
							</div>
						</div>
					</section>
				
				<section className='container  py-5'>
					<div className='row text-center pt-5 pb-3'>
						<div className='col-lg-6 m-auto'>
							<h1 className='h1'>
								{' '}
								<b>Our Services </b>
							</h1>
							<p>At SabZ We provide the following services</p>
						</div>
					</div>
					<div className='row'>
						<div className='col-md-6 col-lg-3 pb-5'>
							<div className='h-100 py-5 services-icon-wap shadow'>
								<div className='h1 text-success text-center'>
									<i className='fa fa-truck fa-lg'></i>
								</div>
								<h2 className='h5 mt-4 text-center'>Delivery Services</h2>
							</div>
						</div>

						<div className='col-md-6 col-lg-3 pb-5'>
							<div className='h-100 py-5 services-icon-wap shadow'>
								<div className='h1 text-success text-center'>
									<i className='fas fa-exchange-alt'></i>
								</div>
								<h2 className='h5 mt-4 text-center'>Shipping & Return</h2>
							</div>
						</div>

						<div className='col-md-6 col-lg-3 pb-5'>
							<div className='h-100 py-5 services-icon-wap shadow'>
								<div className='h1 text-success text-center'>
									<i className='fa fa-percent'></i>
								</div>
								<h2 className='h5 mt-4 text-center'>Promotion</h2>
							</div>
						</div>

						<div className='col-md-6 col-lg-3 pb-5'>
							<div className='h-100 py-5 services-icon-wap shadow'>
								<div className='h1 text-success text-center'>
									<i className='fa fa-user'></i>
								</div>
								<h2 className='h5 mt-4 text-center'>24 Hours Service</h2>
							</div>
						</div>
					</div>
				</section>
				<Footer />

			</>
		)
	}
}
export default About
